import { Component, Input } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { IButtonDownloader } from '../../../../../models/uploader-downloader-btn.model'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { IAnalysisFilesContainerService } from '../i-analysis-files-container.service'

@Component({
    selector: 'app-analysis-files-container',
    templateUrl: './analysis-files-container.component.html',
    styleUrls: ['./analysis-files-container.component.scss'],
    standalone: false
})
export class AnalysisFilesContainerComponent {
  @Input() tagName: string
  @Input() rcaNo: string
  @Input() files: { id: number; name: string; mime: string }[] = []
  @Input() heading: string = ''
  @Input() noFilesText: string = 'No files uploaded.'
  @Input() isLoading: boolean = false
  @Input() deleteDisabled: boolean = false
  @Input() serviceInstance: IAnalysisFilesContainerService

  private _downloader: IButtonDownloader[] = []

  constructor(private responseHandlerService: HttpResponseHandlerService) {}

  public onDeleteFile(file: { id: number; name: string; mime: string }): void {
    if (this.deleteDisabled) {
      return
    }
    this.serviceInstance.deleteFile(file.id, this.tagName, this.rcaNo).subscribe({
      next: (response: any) => {
        this.files = this.files.filter(r => r.id !== file.id)
        this.serviceInstance.notifyFileDeletion(file)
        this.responseHandlerService.notifySuccess('Success!', 'File deleted with success.')
      },
      error: (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
      },
    })
  }

  public onDownloadFile(id: number): void {
    const downloader: IButtonDownloader = this.getDownloader(id)
    downloader.downloading = true
    downloader.progress = 5
    this.serviceInstance.downloadFile(id, this.tagName, this.rcaNo).subscribe({
      next: (response: any) => {
        if (response.status && response.status === 'Progress') {
          downloader.progress = response.message
        }
        if (response.status && response.status === 'Completed') {
          setTimeout(() => {
            downloader.downloading = false
            downloader.progress = 0
          }, 1000)

          const downloadLink: HTMLAnchorElement = document.createElement('a')
          downloadLink.href = `data:${response.mime};base64,${response.base64}`
          downloadLink.download = response.name
          downloadLink.click()
          downloadLink.remove()
        }
      },
      error: (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
        downloader.downloading = false
        downloader.progress = 0
      },
    })
  }

  public isDownloading(id: number): boolean {
    return this.getDownloader(id).downloading
  }

  public getDownloader(id: number): IButtonDownloader {
    if (!this._downloader[id]) {
      this._downloader[id] = { downloading: false, progress: 0 }
    }
    return this._downloader[id]
  }
}
